import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  types,
  getTranscriptsList,
  getTranscriptsListSuccess,
  getTranscriptsListFailure,
  resubmitTranscriptSuccess,
  resubmitTranscriptFailure,
  getAudioLinksByIdFailure,
  getAudioLinksByIdSuccess,
} from '@actions/transcripts';
import {
  getDashboardTranscripts,
  getColudSearchTranscripts,
} from '@services/dashboardResource';
import {
  transformConferenceResponse,
  transformCloudSearchConferenceResponse,
} from '@services/conferenceResource';
import {
  resubmitTranscriptEntry,
  getRecordingsLinks,
} from '@services/transcriptEntryResource';
import { tokenSelector } from '@selectors/authentication';
import { selectCurrentTranscriptId } from '@selectors/conference';

import _ from 'lodash';

export const transcriptsSelector = (state) => state.transcripts;

export function* transcriptsGetListSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const { data } = yield call(
      getDashboardTranscripts,
      action.pageNumber,
      action.numberPerPage,
      token,
      action.filters,
    );
    const transcripts = {
      meta: data.meta,
      list: data.transcripts.map(transformConferenceResponse, false),
    };
    yield put(getTranscriptsListSuccess(transcripts));
  } catch (err) {
    yield put(getTranscriptsListFailure());
  }
}

export function* cloudSearchTranscriptsGetListSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const keyword = action.payload;
    const { data } = yield call(getColudSearchTranscripts, { token, keyword });
    const transcripts = {
      meta: { total: 0, limit: 10, offset: 0 },
      list: data.result
        .map(transformCloudSearchConferenceResponse)
        .sort(({ scoreA }, { scoreB }) => scoreA - scoreB),
    };
    yield put(getTranscriptsListSuccess(transcripts));
  } catch (err) {
    yield put(getTranscriptsListFailure());
  }
}

export function* transcriptsClearFilterSaga() {
  const { currentPage, numberPerPage } = yield select(transcriptsSelector);
  yield put(getTranscriptsList(currentPage, numberPerPage));
}

export function* resubmitTranscriptSaga({ transcriptId }) {
  try {
    const token = yield select(tokenSelector);
    yield call(resubmitTranscriptEntry, transcriptId, token);
    yield put(resubmitTranscriptSuccess(transcriptId));
  } catch (e) {
    yield put(resubmitTranscriptFailure(transcriptId));
  }
}

export function* getRecordingsLinksSaga() {
  try {
    const token = yield select(tokenSelector);
    const transcriptId = yield select(selectCurrentTranscriptId);
    const {
      data: { response },
    } = yield call(getRecordingsLinks, transcriptId, token);
    yield put(getAudioLinksByIdSuccess(response));
  } catch (e) {
    const message =
      _.get(e, 'response.data.error.message') || 'Error while loading recordings';
    yield put(getAudioLinksByIdFailure(message));
  }
}

export default function*() {
  yield takeEvery(types.GET.LIST.STARTED, transcriptsGetListSaga);
  yield takeEvery(types.GET.CLOUD_SEARCH_LIST.STARTED, cloudSearchTranscriptsGetListSaga);
  yield takeEvery(types.RESUBMIT_TRANSCRIPT.STARTED, resubmitTranscriptSaga);
  yield takeEvery(types.CLEAR_FILTERS, transcriptsClearFilterSaga);
  yield takeEvery(types.GET.TRANSCRIPT_RECORDINGS_LINKS.STARTED, getRecordingsLinksSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/transcripts.js